Vue.filter('isShowPrice', function (properties) {
  if (!properties) {
    return true;
  }
  let result = true;
  properties.forEach(function (props) {
    if (props && props.properties) {
      props.properties.forEach(function (prop) {
        if (prop.id == 19) {
          result = false;
        }
      });
    }
  });
  return result;
});
